module.exports = __webpack_public_path__ + "img/title-4.8380a1dd.png";